import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Highlights } from '../models/highligths.class';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { DBCollectionName } from '../enums';

@Injectable({ providedIn: 'root' })
export class HighlightsService extends BaseService<Highlights> {
  constructor(angularFirestore: AngularFirestore) {
    super(DBCollectionName.HIGHLIGHTS, angularFirestore);
  }
}
